import "photoswipe/dist/photoswipe.css";
import { Gallery, Item, useGallery } from "react-photoswipe-gallery";
import { SlideData } from "photoswipe";
import { useQuery } from "@tanstack/react-query";

const GalleryContent = ({ images }: { images: string[] }) => {
  const { open } = useGallery();
  const [image] = images;

  return (
    <div className="relative">
      <Item>
        {({ ref }) => (
          <div ref={ref} className="w-full max-h-[500px] overflow-clip ">
            <img
              className="w-full h-full min-w-32 min-h-8 cursor-pointer object-cover object-center"
              alt={image}
              src={image}
              onClick={() => open(0)}
            />
            {images.length > 1 && (
              <div className="absolute bottom-0.5 right-0.5 px-3 bg-gray-800 rounded-full opacity-70 pointer-events-none whitespace-nowrap">
                <span className="text-white text-xs">See all {images.length}</span>
              </div>
            )}
          </div>
        )}
      </Item>
    </div>
  );
};

const MyGallery = ({
  images
}: {
  images: string[];
  onClose?: () => void;
  selectedImageIndex?: number;
}) => {
  const queryKey = images.join(", ");
  const { isLoading, data } = useQuery({
    queryKey: [queryKey],
    queryFn: () => getImagesWithMetaData(images)
  });

  if (isLoading) {
    return null;
  }

  return (
    <Gallery
      options={{
        dataSource: data
      }}
    >
      <GalleryContent images={images} />
    </Gallery>
  );
};

export default MyGallery;

async function getImagesWithMetaData(images: string[]): Promise<SlideData[]> {
  return Promise.all(images.map((img) => getImageMeta(img)));
}

const getImageMeta = async (imageUri: string): Promise<SlideData> => {
  const img = new Image();
  img.src = imageUri;
  await img.decode();

  return {
    src: imageUri,
    height: img.naturalHeight,
    width: img.naturalWidth
  };
};
